import { useEffect, useRef } from 'react';

// A cold editorial snapshot is built in the background, without delaying the page.
export default function useColdShowcaseRefresh(data, isLoading, refresh) {
  const attempts = useRef(0);
  const latestRefresh = useRef(refresh);
  latestRefresh.current = refresh;
  useEffect(() => {
    if (isLoading || !Array.isArray(data?.data) || data.data.length || attempts.current >= 6) return undefined;
    const timer = setTimeout(() => {
      attempts.current += 1;
      latestRefresh.current();
    }, 4000);
    return () => clearTimeout(timer);
  }, [data, isLoading]);
}
